// @ts-nocheck
import Warning from '@material-ui/icons/Warning.js';
import { Form } from '@sketchpixy/rubix';
import { Entity, ctx as L20NContext  } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import CardIcon from '@material-ui/icons/CreditCard';
import AbilityProvider from '../../permissionsUtils/AbilityProvider.js';
import { CARD_TYPES, ORANGE, PERMISSIONS, PERMISSION_ENTITIES, RED } from '../../_config/consts.js';
import MDButton from '../MDButton/MDButton.jsx';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/RemoveCircleOutline';
import Permission from '../Permission/Permission.jsx';
import CustomField from './Fields/CustomField.jsx';
import { MaximizeTwoTone } from '@material-ui/icons';
import * as ModalActions from '../../redux/actions/modal.actions';
import TranslatableOption from './Fields/TranslatableOption.jsx';
import { localizeHelpCenterLink } from '../../_config/utils.js';
import FormFlatContainer from './Elements/FormFlatContainer.jsx';
import AddCardOutlineIconCustom from '../CustomIcons/AddCardOutlineIconCustom.jsx';


const styles = theme => ({
  button: {
    color: 'red',
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -15,
    width: 'max-content',
  },
});

const validate = values => {
  const errors = {};
  if (!values.deviceId) {
    errors.deviceId = 'required';
  }
  if (!values.deviceType) {
    errors.deviceType = 'required';
  } else if ((values.deviceType === CARD_TYPES.ISEO_CARD || values.deviceType === CARD_TYPES.ISEO_CARD_DESFIRE) && values.deviceId && (!(/^\d+$/.test(values.deviceId)) || _.includes(values.deviceId, ' ')) ) {
    errors.deviceId = 'ISEOcardNumberinvalid';
  } else if (values.deviceType === CARD_TYPES.GENERIC_CARD && values.deviceId && !((/^[0-9A-F]{8}$/i.test(values.deviceId)) || (/^[0-9A-F]{14}$/i.test(values.deviceId)))) {
    errors.deviceId = 'genericCardNumberInvalid';
  } else if (values.deviceType === CARD_TYPES.GENERIC_CARD_DESFIRE && values.deviceId && !(/^[0-9A-F]{14}$/i.test(values.deviceId))) {
    errors.deviceId = 'genericCardNumberInvalid';
  }
  return errors;
};

@reduxForm({ form: 'PrivateUnitDeviceForm', validate })
@connect(state => ({ form: state.form.PrivateUnitDeviceForm }))
class PrivateUnitDeviceForm extends React.Component {
  
  onDeletePrivateUnitDeviceRequest() {
    const { dispatch, form, onDeletePrivateUnitDeviceConfirm } = this.props;
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="deletePrivateUnitDeviceConfirm" />,
        onConfirmText: <Entity entity="yes" />,
        onConfirm: () => onDeletePrivateUnitDeviceConfirm(form.values.id),
        onCancelText: <Entity entity="no" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  onShowCardTypeInfo() {
    const helpURL = localizeHelpCenterLink('supported-rfid-cards');
    window.open(helpURL);
  }

  render() {
    const { onValidateForm, form, classes } = this.props;

    const cardTypes = _.omit(CARD_TYPES, CARD_TYPES.ISEO_PIN)

    return (
      <Form style={{ paddingLeft: 15, paddingRight: 15, marginTop: 20 }}>
        <input style={{ display: 'none' }} type="number" name="id" />
        <FormFlatContainer
          title="privateUnitAddDeviceTitle"
          subtitle="privateUnitAddDeviceSubtitle"
          icon={<AddCardOutlineIconCustom style={{ color: '#3f3f3f', width: 20 }} />}
          style={{ display:'flex', flexDirection:'column' }}
        >
          <div style={{ marginLeft: 5 }}>
            <Entity
              componentClass={Field}
              name="deviceId"
              componentAttribute="placeholder"
              entity="privateUnitDeviceIdInsert"
              title={<Entity entity="privateUnitDeviceId" />}
              component={CustomField}
              disabled={Boolean(form?.values?.id)}
              type="text"
              mandatory
            />
            <Field
              id="deviceType"
              name="deviceType"
              title={<Entity entity="privateUnitDeviceType" />}
              component={CustomField}
              className="form-control-select"
              componentClass="select"
              disabled={Boolean(form?.values?.id)}
              helpText={(
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 10 }} onClick={() => this.onShowCardTypeInfo()}>
                  <InfoIcon style={{ marginRight: 5, color: 'darkblue' }} />
                  <h3 className="link-label" style={{ color: 'darkblue', fontWeight: '100', fontSize: 13, margin: 0 }}>{<Entity entity="cardTypeHelp" />}</h3>
                </div>
              )}
            >
              {_.map(cardTypes, (type, index) =>
                <Entity
                  key={type}
                  componentClass={TranslatableOption}
                  value={type}
                  componentAttribute="text"
                  entity="cardTypes"
                  data={{ type }}
                />)
              }
            </Field>
          {form?.values?.id?(
            <MDButton
              backgroundColor={RED}
              title={<Entity entity="deletePrivateUnitDevice" />}
              onClick={() => this.onDeletePrivateUnitDeviceRequest()}
              icon={<DeleteIcon style={{ color: 'white', marginLeft: 10, fontSize: 15 }} />}
            />
          ):(
            <MDButton
              containerStyle={{ marginTop: 40 }}
              title={<Entity entity="save" />}
              onClick={() => onValidateForm()}
            />
          )}
          </div>
        </FormFlatContainer>
      </Form>
    );
  }
} 

export default withStyles(styles)(PrivateUnitDeviceForm);